import { PopUpTargetBranch } from '../types/popupTargetBranch';
import base from './base';

const popupTargetBranches = {
  getPopUpTargetBranch(branchId: string) {
    return base.get<PopUpTargetBranch>(`/pop-up-target-branches/${branchId}`);
  },
};

export default popupTargetBranches;
